'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _fp = require('lodash/fp');

var _userHelper = require('../../../common/users/userHelper');

var _TeamSuggestionButton = require('./TeamSuggestionButton');

var _TeamSuggestionButton2 = _interopRequireDefault(_TeamSuggestionButton);

var _AdditionalTeamSuggestionsUtil = require('./AdditionalTeamSuggestionsUtil');

var _AdditionalTeamSuggestionsUtil2 = _interopRequireDefault(_AdditionalTeamSuggestionsUtil);

require('./TeamSuggestions.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUGGESTIONS_LIMIT = 2;

var passFilter = function passFilter() {
    return true;
};

var getUsers = function getUsers(state) {
    return state.get('users');
};
var getSelectedUserIds = function getSelectedUserIds(state, props) {
    return props.selectedUserIds || [];
};
var getFilterString = function getFilterString(state, props) {
    return props.filterString;
};
var getCustomFilter = function getCustomFilter(state, props) {
    return props.customFilter || passFilter;
};

var getShareCount = function getShareCount(user) {
    return user && user.get('shareCount') || 0;
};

var sortByShareCount = function sortByShareCount(userA, userB) {
    return getShareCount(userB) - getShareCount(userA);
};
var sortAlphabetically = function sortAlphabetically(userA, userB) {
    var nameA = (0, _userHelper.getName)(userA);
    var nameB = (0, _userHelper.getName)(userB);
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
};

var filterUser = function filterUser(filterString) {
    return function (user) {
        if (!filterString || !filterString.length) return true;

        var filterOn = (0, _fp.lowerCase)(filterString);
        var doesStartWith = (0, _fp.startsWith)(filterOn);
        var doesInclude = (0, _fp.includes)(filterOn);

        return doesInclude((0, _fp.lowerCase)((0, _userHelper.getEmail)(user))) || doesStartWith((0, _fp.lowerCase)((0, _userHelper.getGivenName)(user))) || doesStartWith((0, _fp.lowerCase)((0, _userHelper.getFamilyName)(user)));
    };
};

var unselectedUsersSelector = (0, _reselect.createSelector)(getUsers, getSelectedUserIds, function (users, selectedUserIds) {
    return users.toList().filter(function (user) {
        return !selectedUserIds.includes((0, _userHelper.getId)(user));
    });
});

var suggestedUsersSelector = (0, _reselect.createSelector)(unselectedUsersSelector, getFilterString, getCustomFilter, function (unselectedUsers, filterString, customFilter) {
    return unselectedUsers.filter(filterUser(filterString)).filter(customFilter).sort(sortByShareCount);
});

var limitedSuggestionsSelector = (0, _reselect.createSelector)(suggestedUsersSelector, function (users) {
    return users.slice(0, SUGGESTIONS_LIMIT);
});

var additionalSuggestionsSelector = (0, _reselect.createSelector)(suggestedUsersSelector, function (users) {
    return users.slice(SUGGESTIONS_LIMIT).sort(sortAlphabetically);
});

var shouldShowSuggestionsSelector = (0, _reselect.createSelector)(unselectedUsersSelector, getFilterString, function (unselectedUsers, filterString) {
    return !!(unselectedUsers.size && filterString);
});

var userListSelector = (0, _reselect.createStructuredSelector)({
    suggestedUsers: limitedSuggestionsSelector,
    additionalSuggestedUsers: additionalSuggestionsSelector,
    shouldShowSuggestions: shouldShowSuggestionsSelector
});

var SuggestedUsersList = function SuggestedUsersList(_ref) {
    var suggestedUsers = _ref.suggestedUsers,
        additionalSuggestedUsers = _ref.additionalSuggestedUsers,
        addUser = _ref.addUser;
    return _react2.default.createElement(
        'ul',
        null,
        suggestedUsers.map(function (user) {
            return _react2.default.createElement(
                'li',
                { key: (0, _userHelper.getId)(user) },
                _react2.default.createElement(_TeamSuggestionButton2.default, { user: user, addUser: addUser })
            );
        }),
        _react2.default.createElement(_AdditionalTeamSuggestionsUtil2.default, { users: additionalSuggestedUsers, addUser: addUser })
    );
};

var TeamSuggestions = function TeamSuggestions(props) {
    var filterString = props.filterString,
        suggestedUsers = props.suggestedUsers,
        shouldShowSuggestions = props.shouldShowSuggestions,
        _props$defaultTitle = props.defaultTitle,
        defaultTitle = _props$defaultTitle === undefined ? 'Recent' : _props$defaultTitle;


    if (!shouldShowSuggestions && !suggestedUsers.size) return null;

    var title = filterString ? 'Suggested: ' : defaultTitle + ': ';

    return _react2.default.createElement(
        'div',
        { className: 'TeamSuggestions' },
        _react2.default.createElement(
            'span',
            { className: 'suggestion-title' },
            title
        ),
        suggestedUsers.size ? _react2.default.createElement(SuggestedUsersList, props) : _react2.default.createElement(
            'span',
            { className: 'suggestion-title' },
            'No-one found'
        )
    );
};

SuggestedUsersList.propTypes = TeamSuggestions.propTypes = {
    addUser: _propTypes2.default.func.isRequired,
    suggestedUsers: _propTypes2.default.object,
    additionalSuggestedUsers: _propTypes2.default.object,
    filterString: _propTypes2.default.string,
    defaultTitle: _propTypes2.default.string,
    shouldShowSuggestions: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(userListSelector)(TeamSuggestions);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/teamSuggestions/TeamSuggestions.js
// module id = 757
// module chunks = 0